import { teamsListPageSize } from '@gonfalon/dogfood-flags/dogfood-flags';

import type { TeamsFiltersProps } from './records/TeamsFilters';
import { createTeamsFilters } from './records/TeamsFilters';

export function createTeamsFiltersFromQuery(queryMap: Partial<TeamsFiltersProps>) {
  return createTeamsFilters({
    ...queryMap,
    limit: queryMap.limit || teamsListPageSize(),
  });
}
